import { render, staticRenderFns } from "./PlatformHotspotListEdit.vue?vue&type=template&id=0c562ccd&scoped=true&"
import script from "./PlatformHotspotListEdit.vue?vue&type=script&lang=js&"
export * from "./PlatformHotspotListEdit.vue?vue&type=script&lang=js&"
import style0 from "./PlatformHotspotListEdit.vue?vue&type=style&index=0&id=0c562ccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c562ccd",
  null
  
)

export default component.exports